import { Calendar } from 'components';
import { AuthContext } from 'contexts';
import moment, { type Moment } from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import BookingTimeSelectContext from '../BookingTimeSelectContext';
import DateSelectorCell from './DateSelectorCell';
import DateSelectorHeader from './DateSelectorHeader';

const DateSelectorStep: React.FC = () => {
  const { auth } = useContext(AuthContext);
  const { appointmentDate, onDateClick, getDateStatesForDate, isDisabledDate } =
    useContext(BookingTimeSelectContext);

  const [selectedDate, setSelectedDate] = useState<Moment>(
    moment(appointmentDate),
  );

  useEffect(() => {
    setSelectedDate(moment(appointmentDate));
  }, [appointmentDate]);

  const { isAdmin } = auth;

  // Clicking on a td cell will change the date of the calendar despite being a controlled component 🤦
  const handleAnnoyingAntdClickEvent = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if ('nodeName' in e.target && e.target.nodeName === 'TD') {
      e.stopPropagation();
    }
  };

  return (
    <StyledContainer onClickCapture={e => handleAnnoyingAntdClickEvent(e)}>
      <Calendar
        fullscreen={false}
        value={selectedDate}
        disabledDate={isDisabledDate}
        dateFullCellRender={date => (
          <DateSelectorCell
            {...getDateStatesForDate(date)}
            isAdmin={isAdmin}
            cellDate={date}
            onClick={onDateClick}
          />
        )}
        headerRender={({ value }) => (
            <DateSelectorHeader
              selectedDate={value}
              setSelectedDate={setSelectedDate}
            />
          )}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  max-width: 450px;
  margin: 0 auto;

  /* Antd doesn't offer a way to control how many rows there are so hide the 6th row as it takes up extra space  */
  & tr:nth-child(6) {
    display: none;
  }
`;

export default DateSelectorStep;
